module.exports = __webpack_public_path__ + "static/afolabi-b86db37bff595fd64091d0d672a59499.jpg";